<template>
  <div id="app">

    <router-view></router-view>
  </div>
</template>

<script>

export default {
  name: "App",
  components: {
  },
};
</script>

<style >
#app {
  font-family: "Montserrat", sans-serif;
  margin-top: 0px;
  padding: 0px;
  height: 100%;
  box-sizing: border-box;
}
body {
  /* background-color: rgb(236,239,244);  */
  background-color: rgb(246, 248, 251);
  margin: 0 !important;
  font-family: "Montserrat", sans-serif;
}
</style>
